import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconClipboard: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-0-stroke-1.5-IconClipboard"><Path fillRule="evenodd" clipRule="evenodd" d="M8 2.75C8 2.33579 8.33579 2 8.75 2H15.25C15.6642 2 16 2.33579 16 2.75V4H19.25C19.6642 4 20 4.33579 20 4.75V21.25C20 21.6642 19.6642 22 19.25 22H4.75C4.33579 22 4 21.6642 4 21.25V4.75C4 4.33579 4.33579 4 4.75 4H8V2.75ZM9.5 6.5H14.5V3.5H9.5V6.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconClipboard;
